/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Pay_BodyInputs */

const en_features_pay_body = /** @type {(inputs: Features_Pay_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients pay online when they book, or buy a pack or a subscription. Whatever nobody has paid yet waits under To collect.`)
};

const pl_features_pay_body = /** @type {(inputs: Features_Pay_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient płaci online przy rezerwacji albo kupuje pakiet czy abonament. To, czego nikt jeszcze nie zapłacił, czeka w „Do pobrania”.`)
};

/**
* | output |
* | --- |
* | "Clients pay online when they book, or buy a pack or a subscription. Whatever nobody has paid yet waits under To collect." |
*
* @param {Features_Pay_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_pay_body = /** @type {((inputs?: Features_Pay_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Pay_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_pay_body(inputs)
	return en_features_pay_body(inputs)
});